<div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <a class="logo" href="#" (click)="navigateHome()">
        <img src="http://kwikstore-dev/assets/ksIcon_40.svg" height="40">
        <span class="title-text">{{headerTitle}}</span></a>
    </div>
    <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select> -->
  </div>
  
  <div class="header-container">
    <!-- <nb-menu class="header-menu" tag="headerMenu" [items]="headerMenu"></nb-menu> -->
    <nb-actions size="small">
  
      <nb-action class="control-item custom-item"><a class="header-menu" href="#">Hub</a></nb-action>
      <nb-action class="control-item custom-item"><a class="header-menu" href="/admin/cms">Content Management</a></nb-action>
      <nb-action class="control-item custom-item"><a class="header-menu" href="/admin/kve">Visual Editor</a></nb-action>
      <nb-action class="control-item custom-item">
        <button size="tiny" class="action-button" nbButton [nbContextMenu]="adminMenu" nbContextMenuTrigger="focus" ubsTransformOverlayMenu (click)="wasClicked()">
          Admin Apps
        </button>
      </nb-action>
      <nb-action class="control-item">
        <nb-search type="rotate-layout"></nb-search>
      </nb-action>
      <nb-action class="control-item" icon="email-outline"></nb-action>
      <nb-action class="control-item" icon="bell-outline"></nb-action>
      <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
        <nb-user [nbContextMenu]="userMenu"
                 [onlyPicture]="userPictureOnly"
                 [name]="user?.name"
                 [picture]="user?.picture">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
  
